import { CheckCircle2, Info, XCircle, X } from 'lucide-react';
import { useToastStore, type ToastKind } from '@/store/toast';
import { cn } from '@/lib/cn';

const icon: Record<ToastKind, typeof CheckCircle2> = {
  success: CheckCircle2,
  error: XCircle,
  info: Info,
};

const iconColor: Record<ToastKind, string> = {
  success: 'text-[var(--success)]',
  error: 'text-[var(--error)]',
  info: 'text-[var(--info)]',
};

export function Toaster() {
  const { toasts, dismiss } = useToastStore();

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-2" aria-live="polite">
      {toasts.map((t) => {
        const Icon = icon[t.kind];
        return (
          <div
            key={t.id}
            className="flex items-center gap-3 rounded-DEFAULT border border-line bg-elevated px-4 py-3 shadow-lg animate-fade-in"
            role="status"
          >
            <Icon className={cn('h-5 w-5 shrink-0', iconColor[t.kind])} />
            <span className="text-sm font-medium text-content">{t.message}</span>
            <button
              onClick={() => dismiss(t.id)}
              className="ml-2 text-content-muted transition-colors hover:text-content"
              aria-label="close"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
